// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3ZPed","colCheckbox":"styles_colCheckbox__QnLFW"};